<footer>
  <div class="container">
    <ng-container *ngIf="showTopFooter">
    <div class="row">
      <div class="col-12 col-md-6 order-md-last">
        <p class="text-center">
          Chcesz być na bieżąco z&nbsp;trendami w&nbsp;stylizacji
          i&nbsp;pielęgnacji włosów?
        </p>
        <button class="newsletterBtn" (click)="openNewsletterDialog()">
          Zapisz się do newslettera
        </button>
      </div>
      <div class="col-12 col-sm">
        <img
          class="logo"
          src="/assets/logo/se_white.png"
          alt="Salon Expert logo L'Oréal Professionnel"
        />
      </div>
      <div class="col">
        <nav>
          <ul>
            <li *ngIf="isBusiness()">
              <a routerLink="/biznes/kontakt">Kontakt</a>
            </li>
            <li *ngIf="!isBusiness()"><a routerLink="/kontakt">Kontakt</a></li>

            <li><a [routerLink]="['/salon']">Znajdź Salon</a></li>
            <li *ngIf="!isBusiness()">
              <a routerLink="/biznes">Dla Salonów</a>
            </li>
            <!-- <li><a [routerLink]="['/biznes']" >Dla Salonów</a></li> -->
            <li *ngIf="isBusiness()"><a routerLink="/">Dla Konsumenta</a></li>
          </ul>
        </nav>
      </div>
      <div class="col hide-mobile">
        <nav>
          <ul>
            <li>
              <a
                class="d-flex align-items-center"
                target="_blank"
                rel="nofollow"
                href="https://www.instagram.com/lorealpro/"
              >
                <svg
                  fill="#fff"
                  style="height: 20px; margin: 0 10px 0 0; width: 30px"
                  class="icon"
                  viewBox="0 0 512 512"
                >
                  <use
                    class="d-flex justify-content-center"
                    xlink:href="#instagram"
                    x="0"
                    y="0"
                  />
                </svg>

                Instagram</a
              >
            </li>
            <li>
              <a
                class="d-flex align-items-center"
                target="_blank"
                rel="nofollow"
                href="https://www.facebook.com/LOrealProfessionnelPl/"
              >
                <svg
                  fill="#fff"
                  style="height: 20px; margin: 0 10px 0 0; width: 30px"
                  class="icon"
                  viewBox="0 0 512 512"
                >
                  <use
                    class="d-flex justify-content-center"
                    xlink:href="#facebook-f"
                    x="0"
                    y="0"
                  />
                </svg>

                Facebook</a
              >
            </li>
            <li>
              <a
                class="d-flex align-items-center"
                target="_blank"
                rel="nofollow"
                href="https://www.youtube.com/user/LOrealProfessionnelP/featured"
              >
                <svg
                  fill="#fff"
                  style="height: 20px; margin: 0 10px 0 0; width: 30px"
                  class="icon"
                  viewBox="0 0 512 512"
                >
                  <use
                    class="d-flex justify-content-center"
                    xlink:href="#youtube"
                    x="0"
                    y="0"
                  />
                </svg>

                You Tube</a
              >
            </li>
          </ul>
        </nav>
      </div>
    </div>
    </ng-container>
    <div class="row">
      <div class="col-12 text-center">
        <small
          ><a [routerLink]="['/', 'regulamin-programu']"
            >Warunki korzystania</a
          ></small
        >
        <small
          ><a [routerLink]="['/', 'polityka-prywatnosci']"
            >Polityka prywatności</a
          ></small
        >
        <small
          ><!-- OneTrust Cookies Settings button start -->
          <a
            class="optanon-toggle-display"
            style="text-decoration: underline; cursor: pointer"
            >Ustawienia plików cookie</a
          >
          <!-- OneTrust Cookies Settings button end --></small
        >
        <small><a routerLink="/cookies-policy">Polityka cookies</a></small>
      </div>
    </div>
  </div>
</footer>
